import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import { formatPhoneNumber } from "../../utils/validation"; // adjust path if needed

const OptionalFieldsForm = ({ formData, onChange, onDobChange, errors }) => {
  return (
    <>
      <Grid item xs={12}>
        <Box sx={{ mt: 4, mb: 2 }}>
          <Box
            sx={{
              borderTop: "1px solid #ddd",
              textAlign: "center",
              position: "relative",
              height: "1px",
            }}>
            <Typography
              variant="body2"
              sx={{
                position: "absolute",
                top: "-10px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#fff",
                px: 2,
                color: "#777",
                fontWeight: 500,
              }}>
              More about you (optional)
            </Typography>
          </Box>
        </Box>
      </Grid>

      {/* Phone + Gender */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Phone Number"
          placeholder="(123) 456-7890"
          value={formData.phone}
          onChange={(e) => onChange("phone", formatPhoneNumber(e.target.value))}
          fullWidth
          error={Boolean(errors.phone)}
          helperText={errors.phone || "We may contact you for order updates"}
          FormHelperTextProps={{
            sx: {
              marginLeft: 0,
              color: "#777",
            },
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Gender</InputLabel>
          <Select
            value={formData.gender}
            label="Gender"
            onChange={(e) => onChange("gender", e.target.value)}>
            <MenuItem value="">Prefer not to say</MenuItem>
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>

          <Typography
            variant="caption"
            sx={{ mt: 0.5, ml: 0, color: "#777", display: "block" }}>
            Helps us tailor occasional gifts 🎁
          </Typography>

          {formData.gender === "Other" && (
            <Grid item xs={12}>
              <TextField
                label="Please specify"
                value={formData.customGender}
                onChange={(e) => onChange("customGender", e.target.value)}
                fullWidth
                error={Boolean(errors.customGender)}
                helperText={errors.customGender}
              />
            </Grid>
          )}
        </FormControl>
      </Grid>

      {/* Inline custom gender */}
      {formData.gender === "Other" && (
        <Grid item xs={12}>
          <TextField
            label="Please specify"
            value={formData.customGender}
            onChange={(e) => onChange("customGender", e.target.value)}
            fullWidth
          />
        </Grid>
      )}

      {/* DOB */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 500 }}>
          Birthday
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <TextField
              select
              label="Day"
              value={formData.dob.day}
              onChange={(e) => onDobChange("day", e.target.value)}
              fullWidth>
              {[...Array(31).keys()].map((d) => (
                <MenuItem key={d + 1} value={String(d + 1).padStart(2, "0")}>
                  {d + 1}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <TextField
              select
              label="Month"
              value={formData.dob.month}
              onChange={(e) => onDobChange("month", e.target.value)}
              fullWidth>
              {[
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
              ].map((m, i) => (
                <MenuItem key={m} value={m}>
                  {new Date(0, i).toLocaleString("default", {
                    month: "short",
                  })}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <TextField
              select
              label="Year"
              value={formData.dob.year}
              onChange={(e) => onDobChange("year", e.target.value)}
              fullWidth>
              {Array.from({ length: 100 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <MenuItem key={year} value={String(year)}>
                    {year}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
        </Grid>
        <Typography variant="caption" sx={{ mt: 1, color: "#777" }}>
          We use your birthday to surprise you with something sweet 🎉
        </Typography>
      </Grid>
    </>
  );
};

export default OptionalFieldsForm;
